import Button from '../../common/Button';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      {/* Image Background */}
      <div className="hero__image-wrapper">
        <img
          src="https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=1920&q=80"
          alt=""
          className="hero__bg-image"
        />
        <div className="hero__overlay"></div>
      </div>

      {/* Content */}
      <div className="hero__container">
        <div className="hero__content">

          {/* Main Title */}
          <h1 className="hero__title">
            KO Holistic Health
            <span className="hero__title-accent">and Wellbeing</span>
          </h1>

          {/* Subtitle */}
          <p className="hero__subtitle">
            A gentle, earthy space for energy healing, intuitive guidance,
            and heart-centred transformation
          </p>

          {/* CTA Buttons */}
          <div className="hero__actions">
            <Button href="/contact" size="large" className="hero__btn-primary">
              Begin Your Journey
            </Button>
            <button
              className="hero__btn-secondary"
              onClick={() => document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Services
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="hero__scroll">
          <span>Scroll</span>
          <div className="hero__scroll-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
